export const GET_ALLOWANCES = "GET_ALLOWANCES"
export const GET_ALLOWANCES_SUCCESS = "GET_ALLOWANCES_SUCCESS"
export const GET_ALLOWANCES_ERROR = "GET_ALLOWANCES_ERROR"

export const EDIT_ALLOWANCES = "EDIT_ALLOWANCES"
export const EDIT_ALLOWANCES_SUCCESS = "EDIT_ALLOWANCES_SUCCESS"
export const EDIT_ALLOWANCES_ERROR = "EDIT_ALLOWANCES_ERROR"

